import {
  Checkbox,
  Col,
  DatePicker,
  Input,
  Row,
  Select,
  Space,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import EmptyContent from '../../../components/EmptyContent'
import { DATE_FORMAT_LIST, ISO_DATE_FORMAT } from '../../../constants'
import utils from '../../../utils'

const { RangePicker } = DatePicker
const { Option } = Select

const AdvanceFilterBlock = props => {
  const {
    bookStore,
    loadingAnimationStore,
    authorityStore,
    handleChangeParams,
    internalDocumentStore,
  } = props

  const { queryParamsOutgoing } = internalDocumentStore
  const { bookGroupList, bookListOfGroup } = bookStore
  const { authorityIssuedsList } = authorityStore

  const [loadingBook, setLoadingBook] = useState(false)
  const [valueAuthorityIssued, setValueAuthorityIssued] = useState(
    queryParamsOutgoing.authority_name
      ? [queryParamsOutgoing.authority_name]
      : []
  )
  const [searchTitle, setSearchTitle] = useState(
    queryParamsOutgoing.title || ''
  )
  const [signer, setSigner] = useState(queryParamsOutgoing.signer || '')

  useEffect(() => {
    if (!queryParamsOutgoing.book_group_id) return
    ;(async () => {
      try {
        await bookStore.getBookByBookGroupId(queryParamsOutgoing.book_group_id)
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      }
    })()
  }, [queryParamsOutgoing.book_group_id])

  const onSearchTitle = value => {
    handleChangeParams({ title: value?.trim() || null })
  }

  const onChangeDateIssued = value => {
    handleChangeParams({
      from_date_issued: value ? moment(value[0]).format(ISO_DATE_FORMAT) : null,
      to_date_issued: value ? moment(value[1]).format(ISO_DATE_FORMAT) : null,
    })
  }

  const onChangeDocumentType = document_type => {
    handleChangeParams({ document_type: document_type })
  }

  const onChangeUrgencyLevel = urgency_level => {
    handleChangeParams({ urgency_level: urgency_level })
  }

  const onSearchAuthorityIssued = value => {
    setValueAuthorityIssued(value.length > 0 ? [value[value.length - 1]] : [])
    handleChangeParams({
      authority_name: value.length > 0 ? value[value.length - 1] : null,
    })
  }

  const onSearchSigner = value => {
    handleChangeParams({ signer: value ? value.trim() : null })
  }

  const handleChangeUnread = event => {
    let only_unread = event?.target?.checked ? true : false
    handleChangeParams({ only_unread: only_unread })
  }

  const onChangeBookGroupId = async book_group_id => {
    if (!book_group_id) {
      bookStore.clearBookListOfGroup()
      handleChangeParams({ book_group_id: null, book_id: null })
      return
    }
    setLoadingBook(true)
    handleChangeParams({ book_id: null, book_group_id: book_group_id })
    try {
      await bookStore.getBookByBookGroupId(book_group_id)
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setLoadingBook(false)
    }
  }

  const onChangeBookId = book_id => {
    handleChangeParams({ book_id: book_id })
  }

  const onChangeSignedStatus = value => {
    handleChangeParams({
      is_sign: value !== undefined ? value : null,
    })
  }

  const filterSelectOption = (input, option) => {
    return (
      utils
        .nonAccentVietnamese(option.name)
        .indexOf(utils.nonAccentVietnamese(input)) >= 0
    )
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Row type={'flex'} gutter={15}>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Trích yếu / Số hiệu</span>
            <Input.Search
              value={searchTitle}
              onChange={e => setSearchTitle(e.target.value)}
              onSearch={onSearchTitle}
              placeholder={'Nhập từ khóa tìm kiếm'}
              allowClear
            />
          </Space>
        </Col>

        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Nhóm sổ văn bản</span>
            <Select
              style={{ width: '100%' }}
              loading={loadingAnimationStore.tableLoading}
              allowClear
              onChange={onChangeBookGroupId}
              value={queryParamsOutgoing.book_group_id}
              showSearch
              notFoundContent={<EmptyContent />}
              optionFilterProp={'name'}
              placeholder={'-- Chọn nhóm sổ văn bản --'}>
              {bookGroupList.map(book => (
                <Option key={book.id} value={book.id} name={book.name}>
                  {book.name}
                </Option>
              ))}
            </Select>
          </Space>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Sổ văn bản</span>
            <Select
              style={{ width: '100%' }}
              loading={loadingBook}
              allowClear
              value={queryParamsOutgoing.book_id}
              onChange={onChangeBookId}
              showSearch
              notFoundContent={<EmptyContent />}
              filterOption={true}
              optionFilterProp={'name'}
              disabled={!queryParamsOutgoing.book_group_id}
              placeholder={'-- Chọn sổ văn bản --'}>
              {bookListOfGroup.map(book => (
                <Option key={book.id} value={book.id} name={book.name}>
                  {book.name}
                </Option>
              ))}
            </Select>
          </Space>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Ngày ban hành</span>
            <RangePicker
              onChange={onChangeDateIssued}
              value={
                queryParamsOutgoing.from_date_issued &&
                queryParamsOutgoing.to_date_issued
                  ? [
                      moment(queryParamsOutgoing.from_date_issued),
                      moment(queryParamsOutgoing.to_date_issued),
                    ]
                  : null
              }
              placeholder={['Từ ngày', 'Đến ngày']}
              format={DATE_FORMAT_LIST}
              style={{ width: '100%' }}
            />
          </Space>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Loại văn bản</span>
            <Select
              style={{ width: '100%' }}
              allowClear
              onChange={onChangeDocumentType}
              value={queryParamsOutgoing.document_type}
              notFoundContent={<EmptyContent />}
              placeholder={'-- Chọn loại văn bản --'}>
              <Option value={'020'}>Báo cáo</Option>
              <Option value={'021'}>Công văn</Option>
              <Option value={'022'}>Quyết định</Option>
              <Option value={'023'}>Thông báo - Giấy mời</Option>
              <Option value={'024'}>Tờ trình</Option>
              <Option value={'025'}>Khác</Option>
              <Option value={'026'}>Phiếu lấy ý kiến</Option>
              <Option value={'027'}>Kế hoạch</Option>
              <Option value={'028'}>Biên bản</Option>
              <Option value={'029'}>Quy định</Option>
              <Option value={'030'}>Giấy mời</Option>
              <Option value={'031'}>Công điện</Option>
              <Option value={'032'}>Chương trình</Option>
              <Option value={'033'}>Luật</Option>
              <Option value={'034'}>Điều lệ</Option>
              <Option value={'035'}>Nghị quyết</Option>
              <Option value={'036'}>Chỉ thị</Option>
              <Option value={'037'}>Thông tư</Option>
              <Option value={'038'}>Giấy đi đường</Option>
              <Option value={'039'}>Công văn Đảng ủy</Option>
              <Option value={'040'}>Công văn Công đoàn</Option>
              <Option value={'041'}>Bộ Công Thương</Option>
              <Option value={'042'}>Kiểm định</Option>
              <Option value={'043'}>Đào tạo</Option>
              <Option value={'044'}>Hợp đồng</Option>
            </Select>
          </Space>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Mức độ xử lý</span>
            <Select
              style={{ width: '100%' }}
              allowClear
              onChange={onChangeUrgencyLevel}
              value={queryParamsOutgoing.urgency_level}
              notFoundContent={<EmptyContent />}
              placeholder={'-- Chọn độ khẩn --'}>
              <Option value={'001'}>Thường</Option>
              <Option value={'002'}>Quan trọng</Option>
              <Option value={'003'}>Rất quan trọng</Option>
            </Select>
          </Space>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Bộ phận dự thảo</span>
            <Select
              style={{ width: '100%' }}
              mode="tags"
              value={valueAuthorityIssued}
              onInputKeyDown={() => setValueAuthorityIssued([])}
              onChange={onSearchAuthorityIssued}
              filterOption={filterSelectOption}
              allowClear
              showSearch
              showArrow
              optionFilterProp={'name'}
              notFoundContent={<EmptyContent />}
              placeholder={'-- Chọn hoặc nhập bộ phận dự thảo --'}>
              {authorityIssuedsList.map(authorityIssued => (
                <Option
                  name={authorityIssued.name}
                  value={authorityIssued.name}
                  key={authorityIssued.id}>
                  {authorityIssued.name}
                </Option>
              ))}
            </Select>
          </Space>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Người ký</span>
            <Input.Search
              placeholder={'Người ký'}
              onSearch={onSearchSigner}
              value={signer}
              onChange={e => setSigner(e.target.value)}
              allowClear
            />
          </Space>
        </Col>
        <Col xs={24} sm={12} md={4}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Văn bản ký số</span>
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="-- Chọn trạng thái --"
              onChange={onChangeSignedStatus}
              value={queryParamsOutgoing.is_sign}>
              <Option value={true}>Đã ký số</Option>
              <Option value={false}>Không ký số</Option>
            </Select>
          </Space>
        </Col>
        <Col xs={24} sm={24} md={4}>
          <Space
            direction="vertical"
            style={{ width: '100%', marginBottom: 10 }}>
            <span>Trạng thái văn bản</span>
            <Checkbox
              checked={queryParamsOutgoing.only_unread}
              onChange={handleChangeUnread}>
              Hiển thị văn bản chưa đọc
            </Checkbox>
          </Space>
        </Col>
      </Row>
    </div>
  )
}

AdvanceFilterBlock.propTypes = {}

export default inject(
  'bookStore',
  'loadingAnimationStore',
  'authorityStore',
  'internalDocumentStore'
)(observer(AdvanceFilterBlock))
